// The per-question editor of the product type assessment dialog.
export const T = {
  en_GB: {
    removeOption: "Remove option",
    question: "Question",
    option: "Option",
    score: "Score",
    addOption: "Add option",
    optionsMinHint: "At least 2 options are required.",
    editQuestion: "Edit question",
    editQuestionHint: "Set the question text and its point-scored answer options.",
    done: "Done",
    category: "Category",
    categoryNone: "None",
    categoryHint: "Groups questions for the draw. Never shown to the client.",
  },
  nb_NO: {
    removeOption: "Fjern alternativ",
    question: "Spørsmål",
    option: "Alternativ",
    score: "Poeng",
    addOption: "Legg til alternativ",
    optionsMinHint: "Minst 2 alternativer kreves.",
    editQuestion: "Rediger spørsmål",
    editQuestionHint: "Angi spørsmålsteksten og de poengsatte svaralternativene.",
    done: "Ferdig",
    category: "Kategori",
    categoryNone: "Ingen",
    categoryHint: "Grupperer spørsmål for trekningen. Vises aldri til kunden.",
  },
} as const;
